/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 更新用户密码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  updateRetrievePasswordReq: member.UpdateRetrievePasswordReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/retrieving-password/updating-password`,
    data: updateRetrievePasswordReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
